import React from "react";
import {
    Navigate,
} from "react-router-dom";


const CreditorsListComponent = React.lazy(() => import("../../../../../components/stk-creditor/components/list/page"));
const CreditorsAddComponent = React.lazy(() => import("../../../../../components/stk-creditor/components/add/page"));

export const creditorRoutes = [
   
    {
        path: 'add',
        element: <CreditorsAddComponent />
    },
    {
        path: 'edit',
        element: <Navigate to="/finanzas/creditors/add" />
    },
    {
        path: 'edit/:id',
        element: <CreditorsAddComponent />
    },
     {
        path: 'list',
        element: <CreditorsListComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/finanzas/creditors/list" />
    },
];